var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',[_vm._v("Recipient / Sender")]),_vm._v(" "),_c('v-select',{attrs:{"taggable":"","placeholder":"Choose One","value":_vm.contact,"options":_vm.userOptions,"create-option":(name) => ({
        name: name,
        code: '',
        phone: null,
        email: null,
        tax_id: null,
        address: null,
      }),"label":"name"},on:{"search":_vm.fetUserOptions,"input":_vm.userSelected},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',[_c('span',{staticClass:"text-bold text-capitalize"},[_vm._v(_vm._s(option.name))]),_c('br'),_vm._v(" "),(option.email)?_c('span',[_vm._v(_vm._s(option.email))]):_vm._e()])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }